export const createContainer = ({ id, width, height }) => {
  const container = document.createElement('div')
  const styles = `
    position: absolute;
    pointer-events: none;
    ${width ? `width: ${width}px;` : ''}
    ${height ? `height: ${width}px;` : ''}
  `

  container.setAttribute('id', id)
  container.setAttribute('style', styles)
  document.querySelector('.canvas-container').appendChild(container)

  return container
}
